import styled from '@emotion/styled'
import emailPattern from '../../../email-pattern.webp'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;
  border-radius: 4px;
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
  background-image: url(${emailPattern});
  background-size: contain;
  background-position: center;
  overflow: auto;
  overflow-x: hidden;
`

export const NewTicket = styled.div`
  position: absolute;
  bottom: 10px;
  right: 35px;
  z-index: 10;
`

export const FaqButton = styled.div`
  position: absolute;
  bottom: 10px;
  left: 35px;
  z-index: 10;
`

export const FirstMessage = styled.span`
  text-decoration: underline;
  color: #1da0df;
  margin-inline: 4px;
  cursor: pointer;
`

export const FirstMessageBox = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  gap: 4px;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding-inline: 16px;
`

export const FilterBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  padding: 10px 20px;
  width: 240px;
  direction: rtl;
`

export const FiltersRow = styled.div`
  display: flex;
  flex-direction: column;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  background: #fff;
  ::-webkit-scrollbar {
    display: none;
  }
  .pointer {
    cursor: pointer;
  }
  .icon {
    padding: 4px;
    font-size: 35px;
  }
  .oldest {
    rotate: 180deg
  }
`

export const Name = styled.span`
  width: 100%;
  display: block;
  text-align: center;
`
export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
